import React, { useState } from "react";
import * as S from "./styles";
import * as C from "../../common-styles";
import { useNavigate } from "react-router-dom";
import ColoredLogo from "../../Assets/Images/logo-colored.svg";
import * as interFace from "../../Config/interface.config";
import { Formik, Form } from "formik";
import * as validation from "../../Config/validation.config";
import * as APIPATHS from "../../API/path";
import APIRequest from "../../API";
import toast from "react-hot-toast";

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [formData] = useState<interFace.ForgotPasswordInterface>({
    email: "",
  });

  const onForgotPassword = async (
    values: interFace.ForgotPasswordInterface
  ) => {
    // Your forgot password logic goes here
    const promise = APIRequest(APIPATHS.forgotPassword, values);

    toast.promise(promise, {
      loading: "Sending reset link...",
      success: (data: any) => {
        if (data.error) throw new Error(data.error.message);
        navigate("/login");
        return "Reset link sent successfully.";
      },
      error: (err) => {
        return err.message;
      },
    });
  };

  return (
    <S.ForgotPasswordWrapper>
      <S.ForgotPasswordContainer>
        <S.ColoredLogo src={ColoredLogo} />
        <S.ForgotPasswordContent>
          <h1 className="font-roboto capitalize my-5">Forgot Password</h1>
          <p className="text-white my-8">Enter your email address and we’ll send you a link to reset  your account pasword.</p>
          <Formik
            initialValues={formData}
            onSubmit={onForgotPassword}
            validationSchema={validation.forgotPasswordValidation}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              isSubmitting,
              resetForm,
              isValid,
              dirty,
            }) => (
              <Form className="w-full">
                <div className="forgot-password-form">
                  <div className="my-6">
                    <C.IconInputWrapper>
                      <C.CommonInput
                        placeholder="Type Your Email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </C.IconInputWrapper>
                    <p className="text-white mt-1">
                      {errors.email && touched.email && errors.email}
                    </p>
                  </div>

                  <div className="text-center mb-5 mt-20">
                    <C.CommonButton
                      className="w-full"
                      variant="primary"
                      $isActive={dirty && isValid}
                      type="submit"
                      disabled={isSubmitting || !(dirty && isValid)}
                    >
                      Send Reset Link
                    </C.CommonButton>
                  </div>

                  {/* <div className="text-center">
                    <Link className="text-white" to={"/login"}>
                      Back to Login
                    </Link>
                  </div> */}
                </div>
              </Form>
            )}
          </Formik>
        </S.ForgotPasswordContent>
      </S.ForgotPasswordContainer>
    </S.ForgotPasswordWrapper>
  );
};

export default ForgotPassword;
